import { useState } from 'react';
import { PageHeader } from '@/components/layout/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { 
  Settings, 
  Smartphone, 
  Play,
  RefreshCw
} from 'lucide-react';
import { KioskSettingsTable } from '../components/KioskSettingsTable';
import { KioskDevicesTable } from '../components/KioskDevicesTable';
import { mockKioskSettings, mockKioskDevices } from '../data/mock-kiosk-data';
import { ComingSoonOverlay } from '@/features/dashboard/components/ComingSoonOverlay';

export function KioskPage() {
  const [activeTab, setActiveTab] = useState("settings");

  return (
    <>
      <PageHeader
        title="Kiosk Management"
        description="Configure and manage kiosk display settings and devices."
        actions={
          <>
            <Button variant="outline" size="sm">
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh
            </Button>
            <Button asChild size="sm">
              <a href="/kiosk/preview" target="_blank" rel="noopener noreferrer">
                <Play className="mr-2 h-4 w-4" />
                Preview Kiosk
              </a>
            </Button>
          </>
        }
      />

      <ComingSoonOverlay>
        <Tabs defaultValue="settings" value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList className="grid grid-cols-2 md:w-[400px]">
            <TabsTrigger value="settings" className="flex items-center gap-2">
              <Settings className="h-4 w-4" />
              <span>Settings</span>
            </TabsTrigger>
            <TabsTrigger value="devices" className="flex items-center gap-2">
              <Smartphone className="h-4 w-4" />
              <span>Devices</span>
            </TabsTrigger>
          </TabsList>

          {/* Settings Tab */}
          <TabsContent value="settings">
            <div className="space-y-4">
              <KioskSettingsTable data={mockKioskSettings} />
            </div>
          </TabsContent>

          {/* Devices Tab */}
          <TabsContent value="devices">
            <div className="space-y-4">
              <KioskDevicesTable data={mockKioskDevices} />
            </div>
          </TabsContent>
        </Tabs>
      </ComingSoonOverlay>
    </>
  );
}

export default KioskPage;
